import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Program } from 'types/Program';
import { Panel, PanelItem } from '../../partials/panel';

type ProgramPairsProps = {
	readOnly?: boolean;
	programData: Program;
};

export const ProgramPairs = ({ readOnly = false, programData }: ProgramPairsProps) => {
	const { t } = useTranslation();

	return (
		<Panel title={t('programPanel.dashboard.pairs.title')}>
			<PanelItem
				title={t('programPanel.dashboard.pairs.pairingEnabled')}
				value={programData?.pairingStatus}
				type="boolean"
				transformValue="on/off"
			/>
			<>
				<PanelItem
					title={t('programPanel.dashboard.pairs.acceptedPairs')}
					value={programData?.pairStats?.programPairAcceptedCount}
					transformValue={({ value }) => (
						<>
							{value}
							{!readOnly && (
								<Link
									to={{ pathname: `/program/${programData?.name}/pair/list`, search: '' }}
									className="text-purplish-blue ml-2"
								>
									<i className="fa-solid fa-arrow-up-right-from-square" />
								</Link>
							)}
						</>
					)}
					bold
					large
				/>
				<PanelItem
					title={t('programPanel.dashboard.pairs.mentorsWithoutPair')}
					value={programData?.applicationStats?.mentorsWithoutPairCount}
					transformValue={({ value }) => (
						<>
							{Number(value) > 0 ? <span className="text-danger">{Number(value)}</span> : 0}
							{!readOnly && (
								<Link
									to={{
										pathname: `/program/${programData?.name}/application/list`,
										search: '?applicationRole=mentor&advanced=without-pair',
									}}
									className="text-purplish-blue ml-2"
								>
									<i className="fa-solid fa-arrow-up-right-from-square" />
								</Link>
							)}
						</>
					)}
					bold
				/>
				<PanelItem
					title={t('programPanel.dashboard.pairs.menteesWithoutPair')}
					value={programData?.applicationStats?.menteesWithoutPairCount}
					transformValue={({ value }) => (
						<>
							{Number(value) > 0 ? <span className="text-danger">{Number(value)}</span> : 0}
							{!readOnly && (
								<Link
									to={{
										pathname: `/program/${programData?.name}/application/list`,
										search: '?applicationRole=mentee&advanced=without-pair',
									}}
									className="text-purplish-blue ml-2"
								>
									<i className="fa-solid fa-arrow-up-right-from-square" />
								</Link>
							)}
						</>
					)}
					bold
				/>
			</>
			{!readOnly && (
				<Link
					to={{ pathname: `/program/${programData?.name}/pairing`, search: '' }}
					className="text-purplish-blue"
				>
					{t('programPanel.dashboard.pairs.goToPairingQueue')}{' '}
					<i className="fa-solid fa-arrow-up-right-from-square ml-1" />
				</Link>
			)}
		</Panel>
	);
};
